import { Link } from 'react-router-dom';
import { PublicShell } from '@/components/layout/PublicShell';
import styles from '@/components/layout/PublicForm.module.scss';

export function NotFoundPage() {
  return (
    <PublicShell
      title="Página não encontrada"
      description="O endereço pode estar incorreto ou esta página pode ter sido movida."
      footer={<Link to="/login">Ir para o login</Link>}
    >
      <div className={styles.notFoundCode} aria-hidden="true">404</div>
      <Link to="/" className={styles.submit}>Voltar para a visão geral</Link>
    </PublicShell>
  );
}
